import { Component, Input, OnInit, ElementRef, HostListener } from '@angular/core';
import { columnWidth } from './table.util';
import { GeneralService } from '@core/services/general.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {

  isLoading = false;

  @Input() fontSize: string = "";
  @Input() minSize: string = "";
  @Input() theme: string = "";
  @Input() minWidthValue: string = '';
  @Input() sizeColumns:columnWidth[]=[];
  @Input() infinityScroll:boolean = false;
  @Input() marginButton:boolean = false;

  @Input() set rowCount(value: any) {
    if(value > 0){
      if(this.sizeColumns.length > 0){
        setTimeout(()=>{
          this.assingWidthRows();  
        });  
      }else{
        setTimeout(()=>{
          this.assingColumnSizeDefault();
          this.assingWidthRows();  
        })
      }  
    }else{
      //this.printEmptyResult();
    }
  }

  get rowCount(): any {
    return this.rowCount;
  } 

  thead:any;
  theadClone: any

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    const virtualScroll:any = document.querySelector('.cdk-virtual-scroll-viewport');
    if(virtualScroll && this.theadClone && this.infinityScroll){
      this.theadClone.style.top = virtualScroll.getBoundingClientRect().top+'px';
    }
  }

  constructor(
    private el: ElementRef,
    private generalService:GeneralService) {
      this.generalService.getLoading().subscribe((item:any)=>{
        this.isLoading = item;
        if(this.theadClone){
          this.theadClone.style.opacity = item ? '0.0' : '1.0';
        }
      });
    }

  ngOnInit(): void {
    
    if(this.infinityScroll){

      //ALGORITMO GAUSSEANO.
      //IMPORTANTE: NO QUITAR EL SET TIME OUT SI QUIERES QUE TODO FUNCIONE
      setTimeout(() => {

        this.thead= this.el.nativeElement.querySelector('thead'); //CAPTURA EL THEAD DE LA TABLA
        this.theadClone= this.thead.cloneNode(true);  /* se realiza un clon del thead */
        //this.theadClone.style.opacity = this.isLoading ? '0.0' : '1.0'; 

        this.el.nativeElement.closest('main').appendChild(this.theadClone);  /* Se agrega el clon del thead en la etiqueta main */
        this.theadClone.style.top = this.thead.getBoundingClientRect().top+'px'; /* Se le aplica un top al thead clonado que sea equivalente a la altura inicial de la tabla */
        this.theadClone.style.position = 'fixed'; /* se le aplica una posicion fixed al clon */
        let contentScroll = this.thead.closest('cdk-virtual-scroll-viewport'); /* Se busca en los padres el  cdk-virtual-scroll-viewport */
        const virtualScroll:any = document.querySelector('.cdk-virtual-scroll-viewport');

        /* Si no se encuentra el cdk-virtual-scroll-viewport se busc la clase main */
        if(!contentScroll){
          contentScroll = this.thead.closest('main');
        }

        /* se escuchan los cambios del scroll horizonal  */
        contentScroll.addEventListener('scroll', (event:any)=>{       
          this.theadClone.style.transform = `translateX(-${event.target.scrollLeft}px)`;
        });

        /* ResizeObserver; Detecta cuando un elemento html cambia su tamaño inicial.  */
        const resize_ob = new ResizeObserver((entries) => {
          if(virtualScroll){
            this.theadClone.style.top = virtualScroll.getBoundingClientRect().top+'px'; /* Se le aplica un top al thead clonado que sea equivalente a la altura inicial de la tabla */
          }
          /* Luego de que se detectan las nuevas dimensiones se le asigna al clone esas dimensiones.  */        
          this.thead.querySelectorAll('th').forEach((element: any, index: number) => {
            const th = this.theadClone.querySelectorAll('th')[index];
            if(!th.classList.contains('firts-th')){
              this.theadClone.querySelectorAll('th')[index].style.maxWidth = element.getBoundingClientRect().width + 'px';
              this.theadClone.querySelectorAll('th')[index].style.minWidth = element.getBoundingClientRect().width + 'px';  
            }      
          });
          this.theadClone.style.height = this.thead.getBoundingClientRect().height + 'px';                                
        });    
        // start observing for resize

        // se le aplica al elemento que le queremos observar el crecimiento, en este caso el thead.
        resize_ob.observe(this.thead);

      });

    }

  }

  ngOnDestroy() {
    if(this.infinityScroll && this.theadClone){
      this.theadClone.remove();
    }
  }

  /**
   * Método con el cual le asignamos un ancho predefinido a cada columna de la tabla
   */
  assingWidthRows(){
    //obtenemos el componente table
    const table: any = this.el.nativeElement.querySelector('table');     
    const thead= this.el.nativeElement.querySelector('thead'); //CAPTURA EL THEAD DE LA TABLA
    
    //obtenemos todas las filas de la tabla (las que estén renderizadas en el virtual scroll)
    const rows = table.rows;

    //validamos que hayan filas en la tabla
    if(rows.length > 0){
      //iteramos todas las filas de la tabla
      for(let row of rows){
        
        //verificamos que el elemnto corresponda a un tr(fila)
        if(this.isTrCells(row)){
          //verificamos que el elemento corresponda a un td
          if(!this.isTdCells(row)){
            let i=0;
            for(let cell of row.cells){
              //los items que contenga la llave ignore, se da a entender que no se le asignara un ancho a esa columna
              if(!this.sizeColumns[i].ignore){
                cell.style.width =  this.sizeColumns[i].width;
                cell.style.minWidth =  this.sizeColumns[i].minWidth;
              }
              i++;
            }
          }  
        }
      }
    }else{
      thead.style.display = 'block';
    }

    if(this.infinityScroll){
      setTimeout(() => {
        //volvemos a reasignar el ancho a los th, una vez generadas las filas
        this.thead.querySelectorAll('th').forEach((element: any, index: number) => {
          const th = this.theadClone.querySelectorAll('th')[index];
          if(!th.classList.contains('firts-th')){
            this.theadClone.querySelectorAll('th')[index].style.maxWidth = element.getBoundingClientRect().width + 'px';
            this.theadClone.querySelectorAll('th')[index].style.minWidth = element.getBoundingClientRect().width + 'px';  
          }      
        });
        this.theadClone.style.height = this.thead.getBoundingClientRect().height + 'px'; 
      })
    }
    
    //detectamos si se han generado nuevas filas en la tabla, ya que al hacer scroll se iran rendereizando nuevcos elementos y debemos recalcular las dimensiones de la columna
    this.detectChangesRow(table);    

    /*
    const virtualScroll:any = document.querySelector('.cdk-virtual-scroll-viewport');
    console.log(virtualScroll);
    const positionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        console.log(entry);
        if(entry.isIntersecting){
          if(entry.intersectionRect.top != this.theadClone.getBoundingClientRect().top){
            this.theadClone.style.top = entry.intersectionRect.top+'px';            
          }
        }
      });
    });        
    positionObserver.observe(virtualScroll);     
    */
  }

  /**
   * Método con el cual detectamos si se han renderizado nuevos elementos en la tabla
   * @param table pasamos como argumento el componente table
   */
  detectChangesRow(table:any){

    //creamos un MutationOberserver, el cual detectará si se han agregado o creado nuevos elementos en la tabla(TR)
    const observer = new MutationObserver((mutations) =>{
      mutations.forEach((mutation)=> {
        //realizamos el recorrido de los elementos o nodos que se agregaron a la tabla
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          //obtenemos el tr
          const tr:any = mutation.addedNodes[i];
          
          //validamos que el elemento realmente sea un tr
          if(this.isTrCells(tr)){
            //validamos que el elemento sea un td
            if(!this.isTdCells(tr)){
              let j=0;
              //realizamos la asignación de ancho a cada columna
              for(let cell of tr.cells){
                if(!this.sizeColumns[j].ignore){
                  cell.style.width =  this.sizeColumns[j].width;
                  cell.style.minWidth =  this.sizeColumns[j].minWidth;
                }
                j++;
              }
            }  
          }
        }
      })
    });
    
    //ejecutavos el observer, pasandole como argumento el componente al cual deseamos detectar los cambios
    observer.observe(table, {         
      attributes: true,
      childList: true,
      characterData: true, 
      subtree: true    
    });    

  }

  //creamos un array con los anchos por defecto que generara el componente, esto en caso que no se le asigne ningun ancho, el ancho de todas las columnas para este caso será el mismo, en valores porcentuales
  assingColumnSizeDefault(){
    this.thead= this.el.nativeElement.querySelector('thead'); //CAPTURA EL THEAD DE LA TABLA
    let length = this.thead.querySelectorAll('th').length-1;
    this.thead.querySelectorAll('th').forEach((element: any, index: number) => {
      if(!element.classList.contains('firts-th')){
        if(length > 0){
          this.sizeColumns.push({width: (100/length)+'%', minWidth: (100/length)+'%'});      
        }
      }else{
        this.sizeColumns.push({width: '0%', minWidth: '0%'})
      }    
    });
  }

  //método el cual devolverá un booleano, si el elemento corresponde a un th devolverá true
  isTdCells(row:any):boolean{
    let isTH:boolean=false;
    for(let item of row.cells){
      if(item.nodeName == 'th' || item.nodeName == 'TH'){
        isTH = true;
      }
    }
    return isTH;
  }

  isTrCells(row:any):boolean{
    let isTR:boolean=false;
    if(row.nodeName == 'tr' || row.nodeName == 'TR'){
      isTR = true;
    }
    return isTR;
  }  

  /*
  printEmptyResult(){
    const table= this.el.nativeElement.querySelector('table'); //CAPTURA EL THEAD DE LA TABLA
    
    console.log('rows length', table.columns.length);
  }*/

}
